import React from 'react';

const LoadingSpinner = ({ size = '2rem', color = 'var(--primary-color)' }) => {
    return (
        <i className="pi pi-spin pi-spinner" style={{ fontSize: size, color }}></i>
    );
};

export default LoadingSpinner;
